import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Deviation, DeviationType } from '../../store/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NOT_AVAILABLE } from '../../common/constants/template.constant';
import { PipesModule } from '../../common/pipes/pipes.module';
import { isNil } from 'lodash';

enum DeviationKeyEnum {
  ArrivalDeviation = 'arrivalDeviation',
  DepartureDeviation = 'departureDeviation',
}

@Component({
  selector: 'ui-deviation-type',
  imports: [CommonModule, MatTooltipModule, TranslateModule, PipesModule],
  templateUrl: './deviation-type.component.html',
  styleUrls: ['./deviation-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviationTypeComponent {
  @Input() deviation: Deviation | null = null;
  @Input() showInTimeDeviation = false;
  @Input() showTooltipValue = true;

  get tooltipValue(): string {
    if (this.deviation && this.showTooltipValue) {
      const departureDeviation: string = this.translateService.instant(
        `monitoring.transportManagement.houseAirWaybill.${DeviationKeyEnum.DepartureDeviation}`,
      );
      const arrivalDeviation: string = this.translateService.instant(
        `monitoring.transportManagement.houseAirWaybill.${DeviationKeyEnum.ArrivalDeviation}`,
      );
      const shortArrivalDeviation: string = this.translateService.instant(
        `common.text.${DeviationKeyEnum.ArrivalDeviation}`,
      );

      if (this.deviation.hasOwnProperty('arrivalDeviation') && this.deviation.hasOwnProperty('departureDeviation')) {
        return `${departureDeviation}: ${this.getValue(
          DeviationKeyEnum.DepartureDeviation,
          this.deviation,
        )}\n${arrivalDeviation}: ${this.getValue(DeviationKeyEnum.ArrivalDeviation, this.deviation)}`;
      } else {
        return `${shortArrivalDeviation}: ${this.getValue(DeviationKeyEnum.ArrivalDeviation, this.deviation)}`;
      }
    }
  }

  type = DeviationType;

  constructor(private translateService: TranslateService) {}

  private getValue(key: DeviationKeyEnum, deviation: Deviation): string {
    if (isNil(deviation[key])) {
      return NOT_AVAILABLE;
    }

    return `${deviation[key]} ${this.translateService.instant('common.field.hour')}`;
  }
}
